// Not Found
export const NOTFOUNDROUTE = '*';
// Home
export const HOMEROUTE = '/';
// Login
export const SIGNINROUTE = 'signin';
// Contact
// Favorite Route
export const FAVORITEROUTE = 'favorite';
// Checkout Route
export const CHECKOUTROUTE = 'checkout';
// Shop Route
export const SHOPROUTE = 'shop';
export const SHOPWOMENROUTE = 'shop/women';
export const SHOPMENROUTE = 'shop/men';
export const SHOPKIDSROUTE = 'shop/kids';
export const SHOPACCESSORIESROUTE = 'shop/accessories';
export const SHOPCOLLECTIONROUTE = 'shop/:collectionId';
